export const SEARCH_RESET = 'search/RESET';
export const SEARCH_INPUT = 'search/SEARCH_INPUT';
export const GET_SEARCHED_ITEM = 'search/GET_SEARCHED_ITEM';
export const SAVE_SEARCHED_ITEM = 'search/SAVE_SEARCHED_ITEM';
export const UPDATE_SEARCHED_ITEMS = 'search/UPDATE_SEARCHED_ITEMS';
export const SEARCH_RESULTS = 'search/SEARCH_RESULTS';

export const SPACE = '_';

export const BACKSPACE = '<';

export const TRASH = 'trash';

export const SEARCH_HISTORY_CAPACITY = 4;

export const SEARCH_HISTORY_KEY = '_history';

export const SEARCH_DEBOUNCE_MS = 800;

export const MIN_TEXT_LENGTH_TO_SEARCH = 3;

export const MAX_TEXT_LENGTH_TO_SEARCH = 128;
